module.exports = __webpack_public_path__ + "static/media/formNotificationIcon.c9766cee.svg";